import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './views/Home.vue';
import AboutPage from './views/About.vue';
import VisionPage from './views/Vision.vue';
import ProgramsPage from './views/Programs.vue';
import ContactPage from './views/Contact.vue';

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/about', name: 'About', component: AboutPage },
  { path: '/vision', name: 'Vision', component: VisionPage },
  { path: '/programs', name: 'Programs', component: ProgramsPage },
  { path: '/contact', name: 'Contact', component: ContactPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
